module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/swiss@2-165bdf0ef8cc88f96b4aa76296694e72.jpg";